'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitialzeSVGImages = exports.IMAGE_SELECTOR = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('@iconfu/svg-inject');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Icon
 *    Scripts for various icon tasks.
 *
 *  Version:
 *    1.0.0 - 2018/11/30
 */
var IMAGE_SELECTOR = exports.IMAGE_SELECTOR = "img[src*='.svg']";

var InitialzeSVGImages = exports.InitialzeSVGImages = function InitialzeSVGImages() {
  (0, _jquery2.default)(IMAGE_SELECTOR).each(function (e, i) {
    return SVGInject(i);
  });

  //Dom's weird fixing the SVGs to have unique classes for their selectors.
  (0, _jquery2.default)('svg').each(function (i, e) {
    var randomClass = null;
    while (!randomClass) {
      randomClass = 'cust-svg-' + Math.round(Math.random() * 999999);
      if (!(0, _jquery2.default)('.' + randomClass).length) break;
      randomClass = null;
    }

    var self = (0, _jquery2.default)(e);
    self.addClass(randomClass);

    //I'm going to find all root selectors and prepend them with our new specific
    //selector. Some SVGs will have more than one <style>, hence the .each()
    var elStyle = self.find('style');
    (0, _jquery2.default)(elStyle).each(function (i, e) {
      var styleEl = (0, _jquery2.default)(e);
      var elStyleRaw = styleEl.html();
      elStyleRaw = elStyleRaw.split('}').map(function (def) {
        var selectors = def.split('.');
        if (selectors.length < 2) return def;
        selectors[0] = '.' + randomClass + ' ';
        return selectors.join('.');
      }).join('}');

      styleEl.html(elStyleRaw);
    });
  });
};

(0, _jquery2.default)(document).ready(function () {
  return InitialzeSVGImages();
});
(0, _jquery2.default)(document).on('load', IMAGE_SELECTOR, function () {
  return InitialzeSVGImages();
});